import { TimelineTimeframes, Timestamp } from '@griply/types';
import { addMonths, addQuarters, addYears } from 'date-fns';

const incrementFunc: Record<
  TimelineTimeframes,
  (date: Timestamp, amount: number) => Timestamp
> = {
  [TimelineTimeframes.Month]: addMonths,
  [TimelineTimeframes.Quarter]: addQuarters,
  [TimelineTimeframes.Year]: addYears,
  [TimelineTimeframes.FiveYears]: (date, amount) => addYears(date, amount * 5),
};

export const incrementRoadmapReferenceDate = (
  timeframe: TimelineTimeframes,
  referenceDate: Timestamp,
  direction: number,
): Timestamp => incrementFunc[timeframe](referenceDate, direction);
